export interface UserScheduledWorkout {
  id: number
  date: string
  status: number
  scheduleId: number
  workoutId: number
  workoutName: string
  editScheduleId: number
  editScope: "routine" | "phase"
  editLabel: string
  parentWorkoutId?: number
  parentWorkoutName?: string
  parentPhaseName?: string
}

export interface UserScheduledWorkoutsResponse {
  items: UserScheduledWorkout[]
}

export interface RescheduleMissedWorkoutsResponse {
  processedSchedules: number
  notifiedUsers: number
}

export interface AdminUserScheduleRoutine {
  id: number
  name: string
}

export interface AdminUserSchedule {
  id: number
  userId: number
  workoutId?: number
  workoutName?: string
  parentScheduleId?: number
  editScope: "routine" | "phase"
  settings: {
    workoutDays: string[]
    startDate: string
    nrOfWeeks?: number
  }
  routinesInPhase?: AdminUserScheduleRoutine[]
}

export const WORKOUT_DAYS = [
  "MON",
  "TUE",
  "WED",
  "THU",
  "FRI",
  "SAT",
  "SUN",
] as const

export type WorkoutDay = (typeof WORKOUT_DAYS)[number]
